<div *ngIf="show == true || show == 'true'"><ng-content></ng-content></div>
